module.exports = __webpack_public_path__ + "img/Balcony.3225bb2a.jpg";